<template>
  <div>
    <el-button
      size="small"
      style="background: cornflowerblue; color: white"
      :loading="printing"
      @click="handlePrint"
      >打印<span v-if="printing">中...</span></el-button
    >
    <iframe style="display: none"
      ><Print id="printVoucher" ref="printVoucher"></Print
    ></iframe>
  </div>
</template>

<script>
import Print from "./Print.vue";
import printnb from "@plugins/vue-print-nb-printarea";

export default {
  components: {
    Print,
  },
  props: {
    printValue: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      printing: false,
    };
  },
  watch: {
    printValue: {
      handler: function (val, oldVal) {
        console.log(val, "val");
        console.log(oldVal, "oldVal");
        if (val) {
          this.print(val);
        }
      },
      deep: true,
    },
  },
  methods: {
    handlePrint: function () {
      this.$emit("handleOn");
      if (this.printValue) {
        this.print(this.printValue);
      }
    },
    print: async function (fid) {
      this.printing = true;
      const success = await this.$refs.printVoucher.refresh(fid);
      if (!success) {
        this.printing = false;
        return;
      }
      // https://www.npmjs.com/package/vue-print-nb
      new printnb({
        ids: "printVoucher", // * 局部打印必传入id
        standard: "", // 文档类型，默认是html5，可选 html5，loose，strict
        extraHead: "", // 附加在head标签上的额外标签,使用逗号分隔
        extraCss: "", // 额外的css连接，多个逗号分开
        popTitle: "", // title的标题
        endCallback() {
          // 调用打印之后的回调事件
        },
      });
      setTimeout(() => {
        this.printing = false;
      }, 100);
    },
  },
};
</script>

